/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ExpensesService {
    /**
     * List all expenses
     * Get a paginated list of expenses for the authenticated user
     * @param vendorId Filter by vendor ID
     * @param invStatus Filter by expense status
     * @returns any List of expenses
     * @throws ApiError
     */
    public static dd0399645Db746Ef68A9Bcdab69338(
        vendorId?: number,
        invStatus?: string,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/expenses',
            query: {
                'vendor_id': vendorId,
                'inv_status': invStatus,
            },
            errors: {
                401: `Unauthenticated`,
            },
        });
    }
    /**
     * Create a new expense
     * Create a new expense for a vendor
     * @param requestBody
     * @returns any Expense created successfully
     * @throws ApiError
     */
    public static c751Fc8Afec0E421Ff4180Beb6D02E87(
        requestBody: {
            vendor_id: number;
            invoice_no: string;
            sub_total_amount: number;
            tax_amount?: number | null;
            total_amount: number;
            inv_status: string;
            due_date: string;
            inv_date: string;
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/expenses',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Get a specific expense
     * Retrieve details of a specific expense
     * @param id Expense ID
     * @returns any Expense details
     * @throws ApiError
     */
    public static cba9Dcf02E041A8B7A8070D498A6D(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/expenses/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Expense not found`,
            },
        });
    }
    /**
     * Update an expense
     * Update an existing expense
     * @param id Expense ID
     * @param requestBody
     * @returns any Expense updated successfully
     * @throws ApiError
     */
    public static eb395073943129Ebe9C47Ddb07209B54(
        id: number,
        requestBody: {
            inv_status?: string;
            total_amount?: number;
            is_active?: 'Yes' | 'No';
        },
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
        data?: Record<string, any>;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/expenses/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthenticated`,
                404: `Expense not found`,
                422: `Validation error`,
            },
        });
    }
    /**
     * Delete an expense
     * Delete an expense
     * @param id Expense ID
     * @returns any Expense deleted successfully
     * @throws ApiError
     */
    public static c26749846Eda472Abe88D46C3823F030(
        id: number,
    ): CancelablePromise<{
        success?: boolean;
        message?: string;
    }> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/expenses/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthenticated`,
                404: `Expense not found`,
            },
        });
    }
}
